// W2-3 — THE PENDING ATTACHMENT ROW, LIFTED OUT OF App.tsx VERBATIM.
//
// W2-3 needed lines in App.tsx and the ratchet only moves one way, so they were paid for here. It is
// the right place to pay from: this row sits directly above the text box on BOTH Lala surfaces, which
// is exactly where the turn notice lands, and it is the R8 shape already (props in, tree out, no
// state, no hook) — so `scripts/w2-turn-notice.mjs` CALLS it and reads the tree back rather than
// looking at its text.
//
// What that buys, which no regex could: every pending image is proved to point at the AUTH-GATED file
// route rather than at a raw path, the remove control is proved to carry ITS OWN id, and the empty
// case is proved to render nothing at all instead of an empty bar over the composer.
//
// Moved VERBATIM.
import { FileText } from "lucide-react";
import { attachmentUrl } from "../lib/attachments";
import type { LalaAttachment } from "./MessageAttachments";

// The pending row above the composer: what is about to be sent, iMessage style.
export function AttachmentTray({ items, onRemove, uploading, error }: {
  items: LalaAttachment[]; onRemove: (id: string) => void; uploading: boolean; error: string;
}) {
  if (!items.length && !uploading && !error) return null;
  return (
    <div className="attach-tray">
      {items.map((a) => (
        <div key={a.id} className={a.kind === "image" ? "attach-chip attach-chip--image" : "attach-chip"}>
          {a.kind === "image"
            ? <img src={attachmentUrl(a.id)} alt={a.filename} />
            : <span className="attach-chip__doc"><FileText size={14} /> {a.filename}</span>}
          <button type="button" className="attach-chip__x" onClick={() => onRemove(a.id)} aria-label={`Remove ${a.filename}`}>×</button>
        </div>
      ))}
      {uploading ? <span className="attach-tray__status">Attaching...</span> : null}
      {error ? <p className="attach-tray__error">{error}</p> : null}
    </div>
  );
}
